import { Stack, Typography } from '@mui/material'
import GotonNotFound from 'src/assets/images/goton_not_found.png'
import { HEADER_HEIGHT } from 'src/components/header/Header'
/**
 * @deprecated エラー画面の表示制御はより詳細な範囲(場面ごとなど)で個別に管理する。
 */
const DataUnavailableWidget = () => {
  return (
    <Stack
      height={`calc(100vh - ${HEADER_HEIGHT}px)`}
      alignItems="center"
      justifyContent="center"
      spacing={4}
      p={2}
    >
      {/** biome-ignore lint/a11y/noRedundantRoles: 純粋な装飾目的であるため、スクリーンリーダーに読ませない */}
      <img alt="" role="presentation" src={GotonNotFound} />
      <Typography variant="h6" textAlign="center">
        データが見つからないか、データにアクセスする権限がありません。
      </Typography>
    </Stack>
  )
}

export default DataUnavailableWidget
